import PropTypes from 'prop-types';
import React, {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectAuthData} from "../../../redux/selectors/auth.js";
import {useGetUsersQuery,useGetOrganizationUsersQuery} from "../../../redux/api/users.js";
import { orgUsersFilter, usersFilter } from '../../../QueryFilters/queries.js';

function OrganizationUserList({organizationId}) {
    const {t} = useTranslation();
    const {user: {id: userId}} = useSelector(selectAuthData);
    // const {data: {list: users = []} = {},} = useGetUsersQuery({organizationId: organizationId, authenticatedUserId: userId})
    const { data } = useGetOrganizationUsersQuery({id:organizationId,filter:JSON.stringify(usersFilter)})
    return (
        <fieldset className='form__section'>
            <legend className='form__section-label form__section-label--3column'>
                <span>{t('users')}</span>
                <span>{t('email')}</span>
                <span>{t('role')}</span>
            </legend>
            {data?.map((user, index) => (
                <div key={`org-users-${index}`} className='user__wrap'>
                    <p className='user__info--name'>{user?.firstName}</p>
                    <p className='user__info--email'>{user?.email}</p>
                    <p className='user__info--role'>{user?.userOrganizationRoles?.find(r => r?.organizationId ==organizationId)?.roleId == 1 ? "USER" :"ADMIN"}</p>
                    {/* #TODO - QUERY FOR ROLES */}

                </div>
            ))}
        </fieldset>
    );
}

export default OrganizationUserList;

OrganizationUserList.propTypes = {
    organizationId: PropTypes.string.isRequired
};
